const apis = {
    access : 'http://127.0.0.1:8000/api/token/',
    refresh : 'http://127.0.0.1:8000/api/token/refresh/',
    newuser : 'http://127.0.0.1:8000/api/newuser',
    sendideas : 'http://127.0.0.1:8000/api/sendideas',
    addidea : 'http://127.0.0.1:8000/api/addidea',
    editidea : 'http://127.0.0.1:8000/api/editidea',
    deleteidea : 'http://127.0.0.1:8000/api/deleteidea',
    viewedidea : 'http://127.0.0.1:8000/api/viewedidea',
    nominateuser : 'http://127.0.0.1:8000/api/nominateuser',
    collegeascertained : 'http://127.0.0.1:8000/api/collegeascertained',
    sendunnominated : 'http://127.0.0.1:8000/api/sendunnominated',
    sendmyideas : 'http://127.0.0.1:8000/api/sendmyideas',
    sendvariables : 'http://127.0.0.1:8000/api/sendvariables',
    isnominated : 'http://127.0.0.1:8000/api/isnominated',
}

export default apis;